import { useStaggeredAnimation } from '@/hooks/useScrollAnimation';

const solidarityImages = [
  {
    src: 'https://static.readdy.ai/image/5774bb29582c40f5252e7d37d3c89ae3/054cf551d4e509a9cd3e99e3e99a59c4.png',
    alt: 'Campaña solidaria en Clínica Tarija Vitalmedic - Niños y familias en los pasillos',
    tall: true,
  },
  {
    src: 'https://static.readdy.ai/image/5774bb29582c40f5252e7d37d3c89ae3/6e15d9cf2605c7fb8e7b475842bed580.png',
    alt: 'Campaña solidaria - Entrega de regalos a familias en la clínica',
    tall: false,
  },
  {
    src: 'https://static.readdy.ai/image/5774bb29582c40f5252e7d37d3c89ae3/8f437ca447f9e30a66cd90395ef6e93d.png',
    alt: 'Campaña solidaria - Payasos animando a los niños en los pasillos de la clínica',
    tall: false,
  },
];

export default function SolidaritySection() {
  const { ref, isVisible, getDelay } = useStaggeredAnimation();

  return (
    <section className="py-20 md:py-28 px-4 md:px-8 lg:px-12 bg-background-100 relative overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          {/* Left text */}
          <div ref={ref} className={`lg:col-span-4 reveal-left ${isVisible ? 'is-in' : ''}`}>
            <span className="inline-flex items-center gap-2 text-xs font-bold tracking-[0.2em] text-primary-500 uppercase mb-4">
              <span className="w-8 h-px bg-primary-400" />
              Nuestra Gente
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-medium text-foreground-950 mb-5 leading-[1.08]">
              Solidaridad para nuestra <span className="italic text-primary-600">comunidad</span>
            </h2>
            <p className="text-foreground-600 leading-relaxed mb-6">
              En Vitalmedic la salud va más allá de la medicina. Realizamos campañas solidarias para llevar alegría y apoyo a las familias que nos visitan.
            </p>
            <div className="inline-flex items-center gap-3 px-5 py-3 rounded-2xl bg-background-50 border border-background-200">
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-500 text-secondary-950">
                <i className="ri-heart-3-fill text-lg" />
              </div>
              <div>
                <p className="text-sm font-semibold text-foreground-900">Campañas cada año</p>
                <p className="text-xs text-foreground-500">Juntos por la comunidad tarijeña</p>
              </div>
            </div>
          </div>

          {/* Right masonry-ish grid with varied heights */}
          <div className="lg:col-span-8 grid grid-cols-2 gap-4 md:gap-5">
            {solidarityImages.map((img, i) => (
              <div
                key={i}
                className={`group relative rounded-2xl overflow-hidden reveal-scale ${isVisible ? 'is-in' : ''} ${
                  img.tall ? 'row-span-2 h-full min-h-[340px] md:min-h-[440px]' : 'h-[160px] md:h-[212px]'
                }`}
                style={{ transitionDelay: getDelay(i) }}
              >
                <img
                  src={img.src}
                  alt={img.alt}
                  className="w-full h-full object-cover object-top transition-transform duration-[1.1s] group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-secondary-950/70 via-transparent to-transparent opacity-70 group-hover:opacity-90 transition-opacity duration-500" />
                <div className="absolute bottom-0 left-0 right-0 p-4 translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500">
                  <span className="inline-flex items-center gap-2 text-background-50 text-xs font-medium">
                    <span className="w-6 h-6 flex items-center justify-center rounded-full bg-primary-500">
                      <i className="ri-heart-3-line text-xs" />
                    </span>
                    Solidaridad Vitalmedic
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}